export default {
	"CountDown.CountdownToTheEvent": "活动倒计时："
}